import { MetricRegistryTypeId as MetricRegistryTypeId$1, make as make$1 } from '../../internal/metric/registry.esm.js';

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const MetricRegistryTypeId = MetricRegistryTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
const make = make$1;

export { MetricRegistryTypeId, make };
